import { DesignSystemColors } from '@configurations/design-system/design-system-colors.enum';

const chartDefaultColors = [
  DesignSystemColors.PURPLE_201,
  DesignSystemColors.TEAL_051,
  DesignSystemColors.ORANGE_051,
  DesignSystemColors.BLUE_051,
  DesignSystemColors.YELLOW_027,
  DesignSystemColors.GREEN_201,
  DesignSystemColors.PINK_201,
  DesignSystemColors.RED_201,
];

export const getDefaultColorByIndex = (index: number): string => {
  return chartDefaultColors[index % chartDefaultColors.length];
};
